export default __webpack_public_path__ + "static/media/AvenirNextCyr-Regular.d5515aff.ttf";